<div class="cm__container">
  <!-- Single Notification Element -->
  <div id="userProfile" class="col-12 col-sm-7 py-2 mfa__factor-maintenance">
    <div role="alert" class="notification-banner" *ngIf="notificationVisible" [ngClass]="notificationStyle">
      {{ notificationText }}
    </div>
  </div>
  <div class="user-block">
    <h1 class="profile-header">User Profile</h1>
    <form class="form" [formGroup]="userForm" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="firstname"
              id="firstname"
              placeholder="Enter firstname"
            />
            <label for="firstname">First Name</label>
          </div>
          <div class="error-msg" *ngIf="formControls['firstname']?.invalid && formControls['firstname']?.touched">
            <small *ngIf="formControls['firstname']?.hasError('required')">Firstname is required</small>
          </div>
        </div>
        <div class="col-12 col-sm-7"></div>
      </div>
      <div class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="lastname"
              id="lastname"
              placeholder="Enter lastname"
            />
            <label for="lastname">Last Name</label>
          </div>
          <div class="error-msg" *ngIf="formControls['lastname']?.invalid && formControls['lastname']?.touched">
            <small *ngIf="formControls['lastname']?.hasError('required')">Lastname is required</small>
          </div>
        </div>
        <div class="col-12 col-sm-7"></div>
      </div>
      <div class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div
            class="form-group custom-search form-floating"
            [ngClass]="{ error: formControls['email'].hasError('invalidEmail') && formControls['email'].touched }"
          >
            <input
              type="email"
              class="form-control custom-search-input"
              (keyup)="inputOnChange($event.target)"
              formControlName="email"
              id="email"
              placeholder="Enter email"
              name="cm-email"
            />
            <label for="email">Email</label>
            <span
              *ngIf="isEmailVerified && !isEmailChanged && emulatedUser()?.userId === null"
              (click)="checkMFACount($event, 2)"
              class="custom-search-botton"
              tabindex="0"
              (keydown.enter)="checkMFACount($event, 2)"
              role="button"
              aria-label="Remove email Verification"
              aria-describedby="email-verify-error"
            >
              <img src="../../../assets/images/remove.svg" alt="" class="remove-svg" data-was-processed="true" />
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-7 d-flex align-items-center">
          <button
            type="button"
            *ngIf="showVerifyButton('email')"
            [disabled]="IsVerifiedBtnEnabled[2]"
            class="btn btn-primary profile-btn"
            (click)="showVerifySection('email')"
            id="email-verify-btn"
          >
            Verify Contact
          </button>
          <div *ngIf="isEmailVerified && !isEmailChanged && emulatedUser()?.userId === null" class="contact-verify">
            <input
              class="contact-verify-input"
              (click)="checkMFACount($event, 2)"
              type="checkbox"
              id="emailVerified"
              name="emailVerified"
              aria-label="Email Contact Verified"
              value=""
              checked
            />
            <label for="emailVerified" class="form-check-label">Contact Verified</label>
          </div>
        </div>
        <div
          class="error-msg"
          id="email-verify-error"
          role="alert"
          *ngIf="formControls['email']?.invalid && formControls['email']?.touched"
        >
          <small *ngIf="formControls['email']?.hasError('invalidEmail')">Invalid Email</small>
        </div>
      </div>
      <div class="row">
        <div *ngIf="showEmailVerifySection" class="col-12 col-sm-5 emailotp-title fn-input-block">
          <label class="info-text" aria-live="polite">We just sent a security code to validate your email</label>
        </div>
        <div class="col-12 col-sm-7"></div>
      </div>
      <div *ngIf="showEmailVerifySection" class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              (keyup)="validateOtpInput($event)"
              formControlName="emailotp"
              id="emailotp"
              placeholder="Enter Verification Code"
              aria-live="polite"
              aria-describedby="emailotp-error"
            />
            <label for="emailotp">Enter Verification Code</label>
          </div>
          <div
            class="error-msg"
            id="emailotp-error"
            role="alert"
            *ngIf="formControls['emailotp']?.invalid && formControls['emailotp']?.dirty"
          >
            <small *ngIf="formControls['emailotp']?.hasError('pattern') || formControls['emailotp']?.hasError('max')"
              >Invalid Code</small
            >
          </div>
          <div class="resend-link">
            <small class="text-decoration-underline"
              ><a class="link-dark" href="javascript:void(0)" (click)="resendOTP('email')">Resend Code</a></small
            >
          </div>
        </div>
        <div class="col-12 col-sm-7">
          <button
            *ngIf="showemailotpverifybtn"
            type="button"
            (click)="validateOtp('email')"
            [disabled]="IsOTPVerifiedBtnEnabled[2]"
            class="btn btn-primary profile-btn"
            id="emailotp-verify-btn"
          >
            Verify Code
          </button>
        </div>
      </div>

      <div class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div
            class="form-group custom-search form-floating"
            [ngClass]="{
              error:
                formControls['phone'].invalid &&
                formControls['phone'].touched &&
                formControls['phone'].hasError('pattern'),
            }"
          >
            <input
              type="text"
              class="form-control custom-search-input"
              (keyup)="inputOnChange($event.target)"
              formControlName="phone"
              id="phone"
              placeholder="Enter phonenumber"
              aria-describedby="phone-error"
            />
            <label for="phone">Text/SMS message</label>
            <span
              *ngIf="isPhoneVerified && !isPhoneChanged && emulatedUser()?.userId === null"
              (click)="checkMFACount($event, 0)"
              class="custom-search-botton"
              tabindex="0"
              (keydown.enter)="checkMFACount($event, 0)"
              role="button"
              aria-label="Remove Phonenumber Verification"
            >
              <img src="../../../assets/images/remove.svg" alt="" class="remove-svg" data-was-processed="true" />
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-7 d-flex align-items-center">
          <button
            type="button"
            *ngIf="showVerifyButton('phone')"
            [disabled]="IsVerifiedBtnEnabled[0] || emulatedUser()?.userId"
            class="btn btn-primary profile-btn"
            (click)="showVerifySection('phone')"
            id="phone-verify-btn"
            name="cm-phone"
          >
            Verify Contact
          </button>
          <div *ngIf="isPhoneVerified && !isPhoneChanged && emulatedUser()?.userId === null" class="contact-verify">
            <input
              class="contact-verify-input"
              type="checkbox"
              (click)="checkMFACount($event, 0)"
              id="phoneVerified"
              name="phoneVerified"
              aria-label="Phone Contact Verified"
              value=""
              checked
              [disabled]="emulatedUser()?.userId"
            />
            <label for="phoneVerified" class="form-check-label">Contact Verified</label>
          </div>
        </div>
        <div
          class="error-msg"
          id="phone-error"
          role="alert"
          *ngIf="formControls['phone']?.invalid && formControls['phone']?.touched"
        >
          <small *ngIf="formControls['phone']?.hasError('pattern')">Invalid Phone</small>
        </div>
      </div>
      <div class="row">
        <div *ngIf="showPhoneVerifySection" class="col-12 col-sm-5 phoneotp-title fn-input-block">
          <label class="info-text" aria-live="polite" tabindex="0"
            >We just sent a security code to validate your phone number</label
          >
        </div>
        <div class="col-12 col-sm-7"></div>
      </div>
      <div *ngIf="showPhoneVerifySection" class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              (keyup)="validateOtpInput($event)"
              formControlName="phoneotp"
              id="phoneotp"
              placeholder="Enter Verification Code"
              aria-live="polite"
              aria-describedby="phoneotp-error"
            />
            <label for="phoneotp">Enter Verification Code</label>
          </div>
          <div
            class="error-msg"
            id="phoneotp-error"
            role="alert"
            *ngIf="formControls['phoneotp']?.invalid && formControls['phoneotp']?.dirty"
          >
            <small *ngIf="formControls['phoneotp']?.hasError('pattern') || formControls['phoneotp']?.hasError('max')"
              >Invalid Code</small
            >
          </div>
          <div class="resend-link">
            <small class="text-decoration-underline"
              ><a class="link-dark" href="javascript:void(0)" (click)="resendOTP('phone')">Resend Code</a></small
            >
          </div>
        </div>
        <div class="col-12 col-sm-7">
          <button
            *ngIf="showphoneotpverifybtn"
            type="button"
            (click)="validateOtp('phone')"
            [disabled]="IsOTPVerifiedBtnEnabled[0]"
            class="btn btn-primary profile-btn"
            id="phoneotp-verify-btn"
          >
            Verify Code
          </button>
        </div>
      </div>

      <div class="row fn-input-block">
        <div class="col-12 col-sm-5">
          <div
            class="form-group custom-search form-floating"
            [ngClass]="{
              error:
                formControls['audio'].invalid &&
                formControls['audio'].touched &&
                formControls['audio'].hasError('pattern'),
            }"
          >
            <input
              type="text"
              class="form-control custom-search-input"
              (keyup)="inputOnChange($event.target)"
              formControlName="audio"
              id="audio"
              placeholder="Enter Text/SMS message"
              name="cm-audio"
              aria-describedby="audio-error"
              aria-label="Phone number for audio verification"
            />
            <label for="audio">Phone number for audio verification</label>
            <span
              *ngIf="isAudioVerified && !isAudioChanged && emulatedUser()?.userId === null"
              (click)="checkMFACount($event, 1)"
              class="custom-search-botton"
              tabindex="0"
              (keydown.enter)="checkMFACount($event, 1)"
              role="button"
              aria-label="Remove Audio Verification"
            >
              <img src="../../../assets/images/remove.svg" alt="" class="remove-svg" data-was-processed="true" />
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-7 d-flex align-items-center">
          <button
            type="button"
            *ngIf="showVerifyButton('audio')"
            [disabled]="IsVerifiedBtnEnabled[1]"
            class="btn btn-primary profile-btn"
            (click)="showVerifySection('audio')"
            id="audio-verify-btn"
          >
            Verify Contact
          </button>
          <div *ngIf="isAudioVerified && !isAudioChanged && emulatedUser()?.userId === null" class="contact-verify">
            <input
              class="contact-verify-input"
              type="checkbox"
              (click)="checkMFACount($event, 1)"
              id="audioVerified"
              name="audioVerified"
              value=""
              aria-label="Audio Contact Verified"
              checked
              [disabled]="emulatedUser()?.userId"
            />
            <label for="audioVerified" class="form-check-label">Contact Verified</label>
          </div>
        </div>
        <div
          class="error-msg"
          id="audio-error"
          role="alert"
          *ngIf="formControls['audio']?.invalid && formControls['audio']?.touched"
        >
          <small *ngIf="formControls['audio']?.hasError('pattern')">Invalid Phone</small>
        </div>
      </div>
      <div class="row">
        <div *ngIf="showAudioVerifySection" class="col-12 col-sm-5 audiootp-title fn-input-block">
          <span class="info-text" aria-live="polite">We just sent a security code to validate your phone number</span>
        </div>
        <div class="col-12 col-sm-7"></div>
      </div>
      <div *ngIf="showAudioVerifySection" class="row fn-input-block">
        <div class="col-12 col-sm-5 form-group form-floating">
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              (keyup)="validateOtpInput($event)"
              formControlName="audiootp"
              id="audiootp"
              placeholder="Enter Verification Code"
              aria-live="polite"
              aria-describedby="audiootp-error"
            />
            <label for="audiootp">Enter Verification Code</label>
          </div>
          <div
            class="error-msg"
            id="audiootp-error"
            role="alert"
            *ngIf="formControls['audiootp']?.invalid && formControls['audiootp']?.dirty"
          >
            <small *ngIf="formControls['audiootp']?.hasError('pattern') || formControls['audiootp']?.hasError('max')"
              >Invalid Code</small
            >
          </div>
          <div class="resend-link">
            <small class="text-decoration-underline"
              ><a class="link-dark" href="javascript:void(0)" (click)="resendOTP('audio')">Resend Code</a></small
            >
          </div>
        </div>
        <div class="col-12 col-sm-7">
          <button
            *ngIf="showaudiootpverifybtn"
            type="button"
            (click)="validateOtp('audio')"
            [disabled]="IsOTPVerifiedBtnEnabled[1]"
            class="btn btn-primary profile-btn"
            id="audiootp-verify-btn"
          >
            Verify Code
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
